import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import './AdminLogin.css'

const AdminLogin = () => {
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setIsLoading(true)

    try {
      // Sign in with Supabase Auth
      const { data, error: signInError } = await supabase.auth.signInWithPassword({
        email: email.trim(),
        password: password
      })

      if (signInError) {
        console.error('Sign in error:', signInError)
        throw signInError
      }

      if (!data.user) {
        throw new Error('No user data returned')
      }

      // Wait a moment for session to be fully established
      await new Promise(resolve => setTimeout(resolve, 100))

      // Check if user is admin by querying admin_users table
      const { data: adminData, error: adminError } = await supabase
        .from('admin_users')
        .select('id, role')
        .eq('id', data.user.id)
        .single()

      if (adminError) {
        console.error('Admin check error:', adminError)
        console.error('User ID:', data.user.id)
        // User is not an admin, sign them out
        await supabase.auth.signOut()
        throw new Error('Access denied. Admin privileges required.')
      }

      if (!adminData) {
        console.error('No admin data found for user:', data.user.id)
        // User is not an admin, sign them out
        await supabase.auth.signOut()
        throw new Error('Access denied. Admin privileges required.')
      }

      // Success - user is authenticated and is an admin
      navigate('/admin/dashboard')
    } catch (err: any) {
      console.error('Login error:', err)
      // Provide more specific error messages
      if (err.message?.includes('Invalid login credentials') || err.message?.includes('Email not confirmed')) {
        setError(err.message)
      } else if (err.message?.includes('Access denied')) {
        setError(err.message)
      } else {
        setError(err.message || 'Invalid email or password')
      }
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="admin-login-container">
      <div className="admin-login-box">
        <div className="admin-login-header">
          <h1>BOLD! Admin Panel</h1>
          <p>Enter your credentials to access</p>
        </div>

        <form onSubmit={handleSubmit} className="admin-login-form">
          {error && <div className="admin-error">{error}</div>}

          <div className="admin-form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
              placeholder="admin@yourdomain.com"
            />
          </div>

          <div className="admin-form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Enter your password"
            />
          </div>

          <button type="submit" className="admin-login-button" disabled={isLoading}>
            {isLoading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  )
}

export default AdminLogin

